import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { CompaniesService } from 'api';
import { EdgarIssuerNameUpdate } from 'api/models/EdgarIssuerNameUpdate';

export const EDGAR_ISSUER_NAMES_QUERY_KEY = 'edgarIssuerNames';
export const COMMON_PROFILE_COMPANIES_QUERY_KEY = 'commonProfileCompanies';

export const useProfileCompanies = (profileId: number | undefined) =>
  useQuery({
    queryKey: [COMMON_PROFILE_COMPANIES_QUERY_KEY, profileId],
    queryFn: () => CompaniesService.apiCompaniesCommonProfilesCompaniesList(String(profileId!)),
    enabled: profileId != null,
  });

export const useProfileEdgarIssuerNames = (profileId: number | undefined) =>
  useQuery({
    queryKey: [EDGAR_ISSUER_NAMES_QUERY_KEY, 'profile', profileId],
    queryFn: () => CompaniesService.apiCompaniesCommonProfilesEdgarIssuerNamesList(String(profileId!)),
    enabled: profileId != null,
  });

export const useSearchEdgarIssuerNames = (search: string) =>
  useQuery({
    queryKey: [EDGAR_ISSUER_NAMES_QUERY_KEY, 'search', search],
    queryFn: () => CompaniesService.apiCompaniesEdgarIssuerNamesList(search || undefined),
    enabled: search.length > 0,
  });

export const useUpdateEdgarIssuerName = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: EdgarIssuerNameUpdate }) =>
      CompaniesService.apiCompaniesEdgarIssuerNamesPartialUpdate(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EDGAR_ISSUER_NAMES_QUERY_KEY] });
    },
  });
};
